import { SplashScreen } from "./SplashScreen";
import { OfflineBanner } from "./OfflineBanner";
import { UpdatePrompt } from "./UpdatePrompt";
import { InstallBanner } from "./InstallBanner";
import { ToastContainer } from "@/components/Toast";
import { useServiceWorker } from "@/hooks/useServiceWorker";

export function PWAProvider({ children }: { children: React.ReactNode }) {
  useServiceWorker();

  return (
    <>
      <SplashScreen />
      <OfflineBanner />
      {children}
      <ToastContainer />
      <UpdatePrompt />
      <InstallBanner />
    </>
  );
}
